import * as React from 'react';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { useLocalization } from '~/framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const InsertImageButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.commands.activateMediaManager()}
         isDisabled={!editor.state.selection.empty}
         icon={<FontAwesomeIcon icon={faImage} />}
         title={_js('Insert Media')}
      />
   );
};
